module.exports = __webpack_public_path__ + "static/mixit-8d7873e57803dbb87c279022dec8556d.png";